import $ from "jquery";
export default class LoadMore {
    static mount() {
        $(function () {
            $('.load-more').each(function () {
                new LoadMore($(this));
            });
        });
    }
    constructor(node) {
        var _a, _b, _c, _d;
        this.node = node;
        this.ajaxUrl = (_a = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.ajaxUrl) !== null && _a !== void 0 ? _a : '';
        this.ajaxNonce = (_b = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.ajaxNonce) !== null && _b !== void 0 ? _b : '';
        this.type = (_c = this.node.data('type')) !== null && _c !== void 0 ? _c : 'search';
        this.params = (_d = this.node.data('params')) !== null && _d !== void 0 ? _d : {};
        this.loadMoreBtn = $('.load-more__btn', this.node);
        this.totalPagesCount = $('.load-more__pagination', this.node).data('max-pages');
        if (!this.loadMoreBtn.length) {
            return;
        }
        if (!this.node.hasClass('load-more--disabled')) {
            this.initObserver();
        }
        else {
            let that = this;
            $('.load-more--activate', this.node).on('click', function () {
                this.remove();
                that.loadMoreBtn.show();
                that.initObserver();
            });
        }
    }
    initObserver() {
        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0,
        };
        this.observer = new IntersectionObserver((entries) => this.intersectionObserverCallback(entries), options);
        this.observer.observe(this.loadMoreBtn[0]);
    }
    intersectionObserverCallback(entries) {
        entries.forEach(entry => {
            if (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) {
                this.handleLoadMorePosts();
            }
        });
    }
    handleLoadMorePosts() {
        const page = this.loadMoreBtn.data('page');
        if (!page) {
            return null;
        }
        const nextPage = parseInt(page) + 1;
        let postPerPageStr = this.loadMoreBtn.data('post-per-page');
        if (!postPerPageStr)
            postPerPageStr = "3";
        const postPerPage = parseInt(postPerPageStr);
        this.observer.disconnect();
        const data = Object.assign({
            page: nextPage,
            postPerPage: postPerPage,
            action: 'load_more',
            ajax_nonce: this.ajaxNonce,
            type: this.type,
        }, Object.assign({}, this.params));
        $.ajax({
            url: this.ajaxUrl,
            type: 'post',
            data: data,
            success: (response) => {
                this.loadMoreBtn.data('page', nextPage);
                $('.load-more__list', this.node).append(response);
                if (nextPage + 1 > this.totalPagesCount) {
                    this.loadMoreBtn.remove();
                }
                this.observer.observe(this.loadMoreBtn[0]);
            },
            error: (response) => {
                console.log(response);
                this.observer.observe(this.loadMoreBtn[0]);
            },
        });
    }
}
